<red-route-loading></red-route-loading>
<router-outlet></router-outlet>
